import { all } from 'redux-saga/effects';

import AddressFormatSaga from 'redux/addressFormats/sagas';
import AllocationWishSaga from 'redux/allocationWishes/sagas';
import AllocationSaga from 'redux/allocations/sagas';
import AnalyticSaga from 'redux/analytics/sagas';
import CartSaga from 'redux/cart/sagas';
import ClubMemberShipmentsSaga from 'redux/clubMemberShipments/sagas';
import ClubMembershipSaga from 'redux/clubMemberships/sagas';
import ClubPackageSaga from 'redux/clubPackages/sagas';
import ClubSignupSaga from 'redux/clubSignup/sagas';
import ClubSubscriptionShipmentSaga from 'redux/clubSubscriptionShipments/sagas';
import ClubSaga from 'redux/clubs/sagas';
import CustomerSaga from 'redux/customer/sagas';
import CustomerAddressSaga from 'redux/customerAddresses/sagas';
import CustomerCreditCardSaga from 'redux/customerCreditCards/sagas';
import CustomerDashboard from 'redux/customerDashboard/sagas';
import CustomerGiftCardSaga from 'redux/customerGiftCard/sagas';
import CustomerLoyaltySaga from 'redux/customerLoyalty/sagas';
import CustomerLoyaltySummarySaga from 'redux/customerLoyaltySummary/sagas';
import CustomerMetaDataSaga from 'redux/customerMetaData/sagas';
import FormSaga from 'redux/forms/sagas';
import InventoryLocationSaga from 'redux/inventoryLocations/sagas';
import ResourceBundleSagas from 'redux/localization/sagas';
import LoyaltyPointAvailabilitySaga from 'redux/loyaltyPointsAvailability/sagas';
import OrderSaga from 'redux/orders/sagas';
import PersonalizationBlockSaga from 'redux/personalizationBlock/sagas';
import ProductFilterSaga from 'redux/productFilters/sagas';
import ProductSaga from 'redux/products/sagas';
import ReservationAvailabilitySaga from 'redux/reservationAvailabilities/sagas';
import ReservationCartSaga from 'redux/reservationCart/sagas';
import ReservationTypeSaga from 'redux/reservationTypes/sagas';
import ReservationSaga from 'redux/reservations/sagas';
import SettingSaga from 'redux/settings/sagas';
import ShippingSaga from 'redux/shipping/sagas';
import StripeSaga from 'redux/stripe/sagas';

export default function* IndexSaga() {
  yield all([
    AddressFormatSaga(),
    AnalyticSaga(),
    AllocationSaga(),
    AllocationWishSaga(),
    CartSaga(),
    ClubSaga(),
    ClubMembershipSaga(),
    ClubMemberShipmentsSaga(),
    ClubPackageSaga(),
    ClubSubscriptionShipmentSaga(),
    ClubSignupSaga(),
    CustomerDashboard(),
    CustomerGiftCardSaga(),
    CustomerSaga(),
    CustomerAddressSaga(),
    CustomerCreditCardSaga(),
    CustomerLoyaltySaga(),
    CustomerLoyaltySummarySaga(),
    CustomerMetaDataSaga(),
    FormSaga(),
    InventoryLocationSaga(),
    LoyaltyPointAvailabilitySaga(),
    OrderSaga(),
    PersonalizationBlockSaga(),
    ProductSaga(),
    ProductFilterSaga(),
    ResourceBundleSagas(),
    ReservationAvailabilitySaga(),
    ReservationCartSaga(),
    ReservationSaga(),
    ReservationTypeSaga(),
    SettingSaga(),
    ShippingSaga(),
    StripeSaga()
  ]);
}
